import React from "react";
import { MessageSquare, Ruler, HardHat, CheckCircle } from "lucide-react";
import Reveal from "../shared/Reveal";

const STEPS = [
  {
    icon: MessageSquare,
    step: "01",
    title: "Consultation",
    desc: "We walk your home, listen to your goals, and give you an honest assessment — no pressure, no commitment required.",
  },
  {
    icon: Ruler,
    step: "02",
    title: "Design & Quote",
    desc: "You get a fixed-price quote with detailed scope, material selections, and a realistic timeline before any work starts.",
  },
  {
    icon: HardHat,
    step: "03",
    title: "Build",
    desc: "Our crew shows up on time, every day. Daily cleanup, clear communication, and milestone check-ins throughout.",
  },
  {
    icon: CheckCircle,
    step: "04",
    title: "Walkthrough",
    desc: "We walk through the finished project together. Every item on your punch list is resolved before we consider the job done.",
  },
];

export default function ProcessSection() {
  return (
    <section className="py-20 lg:py-28 bg-primary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="font-body text-accent text-sm font-semibold uppercase tracking-[0.18em] mb-3">How It Works</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Our 4-Step Process
          </h2>
          <p className="font-body text-white/65 text-lg">
            Every project follows the same proven process — whether it's a bathroom refresh or a whole-home renovation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {STEPS.map((step, i) => (
            <Reveal
              key={step.step}
              delay={i * 100}
              className="relative"
            >
              {/* Connector line */}
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-px bg-white/15 -translate-y-1/2 z-0" style={{ width: "calc(100% - 4rem)" }} />
              )}
              <div className="relative z-10">
                <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-5 border border-white/15">
                  <step.icon className="w-7 h-7 text-accent" />
                </div>
                <div className="font-heading text-5xl font-bold text-white/10 absolute top-0 right-0">{step.step}</div>
                <h3 className="font-heading text-xl font-bold text-white mb-3">{step.title}</h3>
                <p className="font-body text-sm text-white/65 leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}